import { createSelector } from 'reselect';
import { State } from 'models';
import _orderBy from 'lodash/orderBy';
import get from 'lodash/get';
import { orderByType } from 'utils';

export const selectInvestorBankAccounts = (state: State) =>
  state.investorBankAccounts.bankAccounts;
export const selectSortParams = (state: State) =>
  state.investorBankAccounts.sortParams;

export const getBankAccounts = createSelector(
  selectInvestorBankAccounts,
  selectSortParams,
  (bankAccounts, sortParams) => {
    const { order, orderBy, type } = sortParams;

    return _orderBy(
      bankAccounts,
      (ba) => orderByType(get(ba, orderBy), type),
      order || 'asc'
    );
  }
);
